<template>
    <el-radio-group v-if="mode == 'edit'" v-model="currentValue">
        <el-radio
            v-for="(item, index) in prop.allowedValues"
            :key="index"
            :value="parseInt(item.id)"
        >
            {{ item.name }}
        </el-radio>
    </el-radio-group>
    <p v-else>
        {{ localValueLabel }}
    </p>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.value,
            currentValue: 0,
        };
    },

    computed: {
        localValueLabel() {
            return this.prop.allowedValues.find((value) => parseInt(value.id) == this.currentValue)
                .name;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit('update:modelValue', { ...this.localValue, ['numericValue']: newValue });
        },
        value: {
            handler: function (newValue) {
                this.localValue = newValue;
                this.currentValue = newValue.numericValue;
            },
            deep: true,
        },
    },

    created() {
        if (!this.localValue) {
            this.localValue = JSON.parse(JSON.stringify(this.templateData));
        }
        const defaultValue =
            this.prop?.allowedValues.find((allowed) => allowed.default) ||
            this.prop?.allowedValues[0];
        this.currentValue = this.value ? this.value.numericValue : parseInt(defaultValue.id);

        this.$emit('update:modelValue', {
            ...this.localValue,
            ['numericValue']: this.currentValue,
        });
    },
};
</script>
